export {
  Portal as AlertDialogPortal,
  Root as AlertDialog,
  Trigger as AlertDialogTrigger,
} from "@rn-primitives/alert-dialog";
